import { useContext } from "react";
import { WebsocketsContext } from "./WebsocketsProvider";

export const useWebsockets = () => {
    const { connected, send, receive } = useContext(WebsocketsContext);
    return [connected, send, receive];
}
